
import { computed, defineComponent, h, resolveComponent } from 'vue';

export default defineComponent({
    name: 'RouterLinkConditional',
    props: {
        to: {
            default: '',
            required: false,
            type: String,
        },
        tag: {
            default: '',
            required: false,
            type: String,
        },
        spaEnabled: {
            default: true,
            required: false,
            type: Boolean,
        },
        role: {
            default: null,
            required: false,
            type: String,
        },
    },
    setup(props, { attrs, slots }) {
        const isExternal = computed(() => {
            const external = RegExp('^((f|ht)tps?:)?//(?!' + location.host + ')');
            return external.test(props.to);
        });

        const createLinkChildData = (type: 'ExternalLink' | 'InternalLink' | 'PassThrough') => {
            const ariaCurrent = window.location.pathname === props.to ? 'page' : false;
            switch (type) {
            case 'PassThrough':
                return attrs;
            case 'ExternalLink':
                return {
                    href: props.to,
                    rel: 'noopener',
                    role: props.role,
                    ariaCurrent: ariaCurrent,
                    ...attrs,
                };
            case 'InternalLink':
                return {
                    to: props.to,
                    role: props.role,
                    ariaCurrent: ariaCurrent,
                    ...attrs,
                };
            }
        };

        return () => {
            let element;
            let childData;

            if (props.to) {
                if (isExternal.value || !props.spaEnabled) {
                    element = 'a';
                    childData = createLinkChildData('ExternalLink');
                } else {
                    element = resolveComponent('router-link');
                    childData = createLinkChildData('InternalLink');
                }
            } else {
                element = props.tag ? props.tag : 'div';
                childData = createLinkChildData('PassThrough');
            }

            return h(element, childData, slots);
        };
    },
});
